import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {ClientConfigurationContent} from "./ClientConfigurationContent";
import {withRouterParams} from "../../utils/withRouterParams";

export class ClientConfiguration extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulClientIntegrationsSubmit = this.afterSuccessfulClientIntegrationsSubmit.bind(this);
    }

    afterSuccessfulClientIntegrationsSubmit(data) {
        alert("Se ha actualizado la información con éxito")
    }

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <ClientConfigurationContent clientId={this.props.match.params.id}
                                            navigate={this.props.navigate}
                                            afterSuccessfulClientIntegrationsSubmit={this.afterSuccessfulClientIntegrationsSubmit}
                />
            </div>
        )
    }
}

export default withRouterParams(ClientConfiguration);
